"use client"

import { useAppSelector } from "@/lib/redux/hooks"
import TEBreadcrumb from "../common/TEBreadcrumb"
import { useTranslation } from "react-i18next"
import { useBlogDetail } from "./BlogDetailContainer"

const BlogDetailBreadcrumb = () => {
  const blogFromStore = useAppSelector(state => state.blog.blog_detail.data)
  const blogFromContext = useBlogDetail()
  const blogDetail = blogFromContext?.title ? blogFromContext : blogFromStore
  const { t } = useTranslation()

  return (
    <TEBreadcrumb
      separator="|"
      items={[
        {
          title: t("common.home"),
          path: '/'
        },
        {
          title: blogDetail?.category === 'NEWS' ? t("common.news") : t("common.explore"),
          path: blogDetail?.category ? '/explore?category=' + blogDetail.category.toUpperCase() : ''
        },
        {
          title: blogDetail?.title,
          path: `/explore/${blogDetail?.slug}`
        }
      ]}
    />
  )
}

export default BlogDetailBreadcrumb
